export default "__VITE_ASSET__Bku31lkU__"